module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "onboarding-tours": "static-1.16225"
    },
    "depPathPrefixes": {
      "onboarding-tours": "/onboarding-tours/static-1.16225"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.37662",
    "project": "onboarding-tours",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};